import { z } from 'zod';
import type { BaseProductImageItem } from '../product/components/variants/BaseProductImageItem';

/**
 * 큐레이션 등록/수정 폼이 보유하는 선택 상품 아이템.
 * 선택 화면(SearchedProduct)와 동일한 카드 레이아웃을 노출하기 위한 구조적 최소 필드.
 * - 등록: SearchProductService/LikedProductService 그대로 흘러들어 옴
 * - 수정: CurationGoodsItem을 시드 시 likeCount → heartCount 매핑
 */
export interface CurationFormGoodsItem extends BaseProductImageItem {
  brandName: string;
  brandNo?: number | null;
  price: number;
  salesRate?: number | null;
  heartCount?: number;
  reviewScore?: string;
  reviewCount?: number;
  expectedEarnings?: number;
  webUrl?: string;
  // RADAR 가격/라벨 필드 (수정 시드 + picker 양쪽에서 흘러들어 옴)
  finalPrice?: number | null;
  finalDiscount?: number | null;
  isExclusive?: boolean | null;
  isLowestPrice?: boolean | null;
  existsCoupon?: boolean | null;
}

export const editCurationFormSchema = z
  .object({
    title: z.string(),
    description: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.title || data.title.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '제목을 입력해주세요.',
        path: ['title'],
      });
    }
  });

export type EditCurationFormData = z.infer<typeof editCurationFormSchema>;

export const snapCurationListItemSchema = z.object({
  id: z.string(),
  imageUrl: z.string(),
  linkUrl: z.string(),
});

export type SnapCurationListItem = z.infer<typeof snapCurationListItemSchema>;

export const shopSnapCurationEditFormSchema = z
  .object({
    title: z.string(),
    description: z.string().optional(),
    selectedSnaps: z.array(snapCurationListItemSchema),
  })
  .superRefine((data, ctx) => {
    if (!data.title || data.title.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '제목을 입력해주세요.',
        path: ['title'],
      });
    }
  });

export type ShopSnapCurationEditFormData = z.infer<typeof shopSnapCurationEditFormSchema>;
